export default __webpack_public_path__ + "static/media/Wadi_Degla_Logo.a6180108.png";